
import Vue, { PropType } from 'vue'

import PlantAvatar from '@/ui/components/plants/PlantAvatar.vue'
import JImageGallery from '@/ui/controls/JImageGallery.vue'
// import JImageCard from '@/ui/controls/JImageCard.vue'

import LogItem, { LogItemCategory } from '@/models/LogItem'
import { id } from '@/types/models'
import Image from '@/models/Image'

export default Vue.extend({
  components: {
    PlantAvatar,
    JImageGallery,
    // JImageCard,
  },
  props: {
    value: Object as PropType<LogItem>,
    hidePlants: Boolean,
    dense: Boolean,
  },
  data: () => ({
    imageDialog: false,
  }),
  computed: {
    item(): LogItem {
      return this.value
    },
    cardTitle(): string | undefined {
      switch (this.item.category) {
        case LogItemCategory.Action:
        case LogItemCategory.Milestone:
        case LogItemCategory.Timeline:
          return this.item.type
        case LogItemCategory.Image:
          return this.item.category // undefined
        case LogItemCategory.Water:
          return (
            this.item.category +
            (this.item.type === 'normal' ? '' : ' (' + this.item.type + ')')
          )
        case LogItemCategory.Comment:
          return (
            this.item.category +
            (this.item.type === 'n/a' ? '' : '(' + this.item.type + ')')
          )
        default:
          return this.item.category + ': ' + this.item.type
      }
    },
  },
  methods: {
    getImage(imageId: id): Image {
      return this.$store.getters['gardens/images/find'](imageId)
    },
  },
})
